import Plugin from '../Plugin'


export default class Login extends Plugin {

    constructor(network) {
        super(network)
        this.events = {
            'login': this.login.bind(this),
            'game_auth': this.gameAuth.bind(this)
        }
    }

    get loginScene() {
        return this.scene.getScene('Login')
    }

    login(args) {
        this.interface.hideLoading()

        if (args.success) {
            // Traditional Club Penguin flow: Always go to Servers scene
            // WebAPI auth provides profile and sessionKey
            if (args.sessionKey) {
                return this.scene.start('Servers', {
                    username: args.username || args.profile?.username,
                    profile: args.profile,
                    sessionKey: args.sessionKey,
                    isWebAPI: true
                })
            }
            // Fallback for any legacy data format
            return this.scene.start('Servers', args)
        }

        // Login failed - show error
        if (!this.network.lastLoginScene) {
            return this.scene.start('Login')
        }

        let scene = this.scene.getScene(this.network.lastLoginScene)

        scene.events.once('create', () => this.onLoginError(args.message))
        this.scene.start(this.network.lastLoginScene)
    }

    onLoginError(message) {
        this.loginScene.events.emit('hideinput')

        this.interface.prompt.showError(message, 'Okay', () => {
            this.loginScene.events.emit('showinput')

            this.interface.prompt.error.visible = false
        })
    }

    gameAuth(args) {
        console.log('[Login] game_auth received:', args)
        
        if (args.token) {
            this.network.token = args.token
        }

        if (args.success) {
            console.log('[Login] game_auth successful, sending join_server')
            // Mark authentication as successful
            this.network.onAuthenticationSuccess()
            this.network.send('join_server')
        } else {
            console.error('[Login] game_auth failed:', args.message)
            // Handle game auth failure
            this.interface.hideLoading()
            this.interface.prompt.showError(args.message || 'Authentication failed', 'Okay', () => {
                this.interface.prompt.error.visible = false
                // Return to login
                this.scene.start('Start')
            })
        }
    }

}
